'use client';

import ContentLoader from '@/components/common/ContentLoader';

export default function Loading() {
  return <ContentLoader fullPage />;
}
